const API_URL: string = 'https://api.kinomap.dev/v4/';
const OAUTH_URL: string = 'https://login.kinomap.dev/';
const WEBSITE: string = 'https://www.kinomap.dev';

export const environment = {
  production: false,
  client_id: 1,
  client_secret: 'pRFFDCLeFKlFlQyNs3jWErL4bu3APNqi0XKn7hQj',
  websiteAppToken:
    '1cey0vihf7f5359ddfaapxxiptpmvqzq9ce12442rzvk1dolflmd7d3bn6egzeofksgh4jwd4wmmmomxcotfqovcc3qkvr342bwk4ga1v5b3ngsshrnfukyj',
  scope: '*',
  urls: {
    api_url: `${API_URL}`,
    website_url: `${WEBSITE}`,
  },
  analytics: {
    API_SECRET: "fH_3HN5jS7uo1LQj2OD7rg",
    GA_CODE: "G-14KEB1S992"
  },
  api: {
    login: `${API_URL}oauth/token`,
    authorize: `${API_URL}oauth/authorize`,
    loginProvider: `${API_URL}oauth/sso/login/`,
  },
  allowedRedirectHosts: ['kinomap.dev', 'fitimmersion.com', 'localhost'],
  clientsList: [
    {
      client_id: '50',
      client_name: 'kinomap',
      logo_url: 'none',
      scopes: [],
    },
    {
      client_id: '51',
      client_name: 'admin',
      logo_url: 'none',
      scopes: [],
    },
    {
      client_id: '52',
      client_name: 'admin-v2',
      logo_url: 'none',
      scopes: [],
    },
    {
      client_id: '53',
      client_name: 'creator',
      logo_url: 'none',
      scopes: [],
    },
    {
      client_id: '54',
      client_name: 'beta',
      logo_url: 'none',
      scopes: [],
    },
    {
      client_id: '55',
      client_name: 'leaderboard',
      logo_url: 'none',
      scopes: [],
    },
    {
      client_id: '56',
      client_name: 'quick-translate',
      logo_url: 'none',
      scopes: [],
    },
    {
      client_id: '60',
      client_name: 'fitimmersion',
      logo_url: 'none',
      scopes: [],
    },

    {
      client_id: '2',
      client_name: 'sportheroes',
      logo_url: 'assets/clients_icons/sport-heroes-logo.svg',
      scopes: ['activities'],
    },
    {
      client_id: '3',
      client_name: 'technogym',
      logo_url: 'assets/clients_icons/technogym-logo.svg',
      scopes: ['activities'],
    },
    {
      client_id: '6',
      client_name: 'defit',
      logo_url: 'assets/clients_icons/defit-logo.svg',
      scopes: ['activities'],
    },
    {
      client_id: '7',
      client_name: 'strava',
      logo_url: 'assets/clients_icons/strava.svg',
      scopes: ['activities'],
    },
  ],

  sso: {
    //✅ Google
    google: {
      client_id:
        '466170937286-3is3bbb1sgjp6im83mfivbimdp22mf2i.apps.googleusercontent.com',
      loginUrl: API_URL + 'oauth/sso/loginGoogle',
    },
    //✅ Apple
    apple: {
      loginUrl: API_URL + 'oauth/sso/loginApple',
      redirect_url: OAUTH_URL + 'callback/apple',
    },

    //❓ Strava
    strava: {
      loginUrl: 'https://www.strava.com/oauth/authorize',
      redirectUrl: OAUTH_URL + 'callback/strava',
      config: {
        client_id: 8927,
      },
    },

    //❌ Decathlon
    decathlon: {
      loginUrl: 'https://api.preprod.decathlon.net/connect/oauth/authorize',
      redirectUrl: OAUTH_URL + 'callback/decathlon',
      config: {
        scope_requiered: 'profile openid email sports_tracking_data',
        client_id: '7698bf2f-ea17-444c-8cbe-ee6d12429211',
      },
    },
  },
};
